import { DublicateClientsSettingsPage } from '@pages/DublicateClientsSettings/ui';

export const DublicateClientsSettings = {
  Page: DublicateClientsSettingsPage,
};
